import { render, staticRenderFns } from "./SystemServiceInfo.vue?vue&type=template&id=f60189ac"
import script from "./SystemServiceInfo.vue?vue&type=script&lang=js"
export * from "./SystemServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemServiceInfo.vue?vue&type=style&index=0&id=f60189ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports